"use client";
import { useState } from "react";
import { useSnowplowFormTracking } from "./useSnowplowFormTracking";
import { useSnowplowUserContext } from "./useSnowplowUserContext";
/**
 * Tracks snowplow activity within Modal, Dialog, Drawer, Menu and Popover components.
 */
export var ModalSnowplowTracker = function (props) {
    var isEnabled = props.isEnabled, setUserContext = props.setUserContext;
    var _a = useState(false), userUpdated = _a[0], setUserContextUpdated = _a[1];
    useSnowplowUserContext({ isEnabled: isEnabled, setUserContext: setUserContext, setUserContextUpdated: setUserContextUpdated });
    useSnowplowFormTracking({ isEnabled: isEnabled, userUpdated: userUpdated });
    return null;
};
